import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { AssetPipe } from '../../../../../../pipes/asset.pipe';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { QuickLinkService } from '../../../../../../services/quick-link.service';
import { RouteService } from '../../../../../../services/route.service';
import { NgStyle } from '@angular/common';
import { PageService } from '../../../../../../services/page.service';

@Component({
    selector: 'app-default-welcome-content',
    templateUrl: './default-welcome-content.component.html',
    styleUrls: ['./default-welcome-content.component.scss'],
    imports: [
        AssetPipe,
        NgStyle
    ],
    standalone: true
})
export class DefaultWelcomeContentComponent implements OnInit {
    @Input() modalId: string;
    @Input() showContent: boolean;
    @Output() readonly change = new EventEmitter();

    applicationStateService = inject(ApplicationStateService);
    quickLinkService = inject(QuickLinkService);
    routeService = inject(RouteService);
    pageService = inject(PageService);
    coverURL: string;

    generalText: string;
    hsmText: string;
    gmtText: string;
    eSquirrelText: string;
    defaultPrefix = 'gm1';

    ngOnInit() {
        this.coverURL = this.pageService.getPageByIndex(0).image.url;
        this.defaultPrefix = (this.applicationStateService.bookConfig.quickLinkPrefix || 'gm1').substr(0, 3);

        // Does not use this.applicationStateService.platformDomain because the domain name might be too long.
        const domainName = 'digi.schule';
        this.generalText = `${domainName}/${this.defaultPrefix}1b1`;
        this.hsmText = `${domainName}/<br/><span>${this.defaultPrefix}hsm11</span>`;
        this.gmtText = `${domainName}/<br/><span>${this.defaultPrefix}gmt14</span>`;
        this.eSquirrelText = `${domainName}/<br/><span>${this.defaultPrefix}eSquirrel1</span>`;
    }
}